"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const General_1 = require("../../types/General");
const buildCallableAudioGetTrackList = (args) => async ({ functionId, callbacks, executeProcesses, }) => {
    try {
        const trackList = await args.getTrackList();
        executeProcesses(functionId, callbacks[General_1.DEFINITION_PROP_NAMES.THEN], trackList);
    }
    catch (error) {
        executeProcesses(functionId, callbacks[General_1.DEFINITION_PROP_NAMES.CATCH], `${error}`);
    }
};
exports.default = buildCallableAudioGetTrackList;
